module.exports = __webpack_public_path__ + "static/pic2-2f96c284a1d91891e0c2bca2f5b30854.jpg";